import { staffsService } from "Services/StaffsService";

const store = {
    namespaced: true,
    state() {
        return {
            staffs: []
        }
    },
    getters: {
        getStaffs: (state) => state.staffs,
        getOneStaff: (state) => (id) => state.staffs.find(item => item.id === id),
        getStaffStatus: (state) => (id) => {
            const staff = state.staffs.find(item => item.id === id)
            return (staff) ? staff.status : 'deleted'
        },
        isStaffDeleted: (state) => (id) => {
            const staff = state.staffs.find(item => item.id === id)
            return !staff
        },
        isStaffBlocked: (state) => (id) => {
            const staff = state.staffs.find(item => item.id === id)
            return !(!staff || staff.status === 'ok');
        },
    },
    mutations: {
        setStaffs(state, payload) {
            state.staffs = payload
        }
    },
    actions: {
        async fetchStaffs({commit}) {
            try {
                const staffs = await staffsService.fetchStaffs()
                commit('setStaffs', staffs)
            } catch (e) {
                console.error(e)
            }
        },
    }
}

const factory = () => {
    return new Promise(async (resolve, reject) => {
        const staffs = await staffsService.fetchStaffs()
        resolve({
            ...store,
            state: {
                ...store.state,
                staffs
            }
        })
    })

}

export { store as default, factory }
